import { Tag, TagSkeleton } from "@carbon/react";
import React from "react";

import { useGetCaseTypesSchemasQuery } from "src/graphql/anti-fraud/queries/caseTypes/CaseTypesSchemasQuery";
import { CaseTypeDefinition, Color } from "src/types/case";

// Composant pour quand on a déjà les définitions de case types
type CaseTypeTagProps = {
  caseTypeCode: string;
  caseTypeDefinitions?: CaseTypeDefinition[];
  fallbackType?: Color;
};

export const CaseTypeTag: React.FC<CaseTypeTagProps> = ({
  caseTypeCode,
  caseTypeDefinitions,
  fallbackType = "magenta",
}) => {
  if (!caseTypeCode) return null;

  const caseType = caseTypeDefinitions?.find((caseType) => caseType.code === caseTypeCode);

  return caseType ? (
    <Tag type={caseType.tag}>{caseType.label}</Tag>
  ) : (
    <CaseTypeDefaultTag caseTypeCode={caseTypeCode} type={fallbackType} />
  );
};

// Composant pour quand on n'a pas les définitions (fait une requête GraphQL)
type CaseTypeDefaultTagProps = {
  caseTypeCode: string;
  type: Color;
};

export const CaseTypeDefaultTag: React.FC<CaseTypeDefaultTagProps> = ({ caseTypeCode, type }) => {
  const { data: caseTypes, error, loading } = useGetCaseTypesSchemasQuery();

  if (loading) {
    return <TagSkeleton size="sm" />;
  }

  if (error) {
    return null;
  }

  const caseType = caseTypes?.find((caseType) => caseType.code === caseTypeCode);

  return caseType ? <Tag type={type}>{caseType.name}</Tag> : <Tag type={type}>{caseTypeCode}</Tag>;
};
